import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

import axiosApi from "../Utils/axiosApi";
import checkPermission from '../Utils/checkPermission';
const CreateSalesAgentDialog = ({
  open,
  onClose,
  formData,
  setFormData,
  onSubmit,
  isEdit = false,
}) => {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
const [users, setUsers] = useState([]);

const userRole = sessionStorage.getItem("userRole");
const isAdmin =
  String(userRole || "").toUpperCase() === "ADMIN";  
  // ✅ Load countries
  useEffect(() => {
    axiosApi.post("/country/getCountry", {}).then((res) => {
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.countries || [];
      setCountries(data);
    });
  }, []);

  // ✅ Load states
  useEffect(() => {
    if (!formData.countryId) {
      setStates([]);
      return;
    }

    axiosApi
      .post("/state/getState", { countryIds: [formData.countryId] })
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.states || [];
        setStates(data);
      });
  }, [formData.countryId]);

  // ✅ Load districts
  useEffect(() => {
    if (!formData.stateId) {
      setDistricts([]);
      return;
    }

    axiosApi
      .post("/district/getDistrict", { stateIds: [formData.stateId] })
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.districts || [];
        setDistricts(data);
      });
  }, [formData.stateId]);

  // ✅ Load cities
  useEffect(() => {
    if (!formData.districtId) {
      setCities([]);
      return;
    }

    axiosApi
      .post("/city/getCity", { districtIds: [formData.districtId] })
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : res.data.cities || [];
        setCities(data);
      });
  }, [formData.districtId]);
useEffect(() => {
  const loadUsers = async () => {
    if (!isAdmin) {
      return;
    }

    try {
      const payload = {
        roleCodes: ["ADMIN", "SALES_MANAGER"]
      };

      const response = await axiosApi.post(
        "/userManagement/getUsers",
        payload
      );

      const userList =
        response?.data?.users ||
        response?.data?.applicationUserDTOs ||
        response?.data ||
        [];

      setUsers(userList);
    } catch (error) {
      console.error(error);
    }
  };

  loadUsers();
}, [isAdmin]);


  
  
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        {isEdit ? "Edit Property" : "Create Property"}
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>

          {/* PROPERTY NAME */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Property Name"
              value={formData.propertyName}
              onChange={(e) =>
                setFormData({ ...formData, propertyName: e.target.value })
              }
            />
          </Grid>

          {/* TYPE */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Type"
              value={formData.propertyType}
              onChange={(e) =>
                setFormData({ ...formData, propertyType: e.target.value })
              }
            >
              <MenuItem value="Hostel">Hostel</MenuItem>
              <MenuItem value="PG">PG</MenuItem>
              <MenuItem value="Apartment">Apartment</MenuItem>
              <MenuItem value="Hotel">Hotel</MenuItem>
            </TextField>
          </Grid>

          {/* OWNER */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Owner Name"
              value={formData.ownerName}
              onChange={(e) =>
                setFormData({ ...formData, ownerName: e.target.value })
              }
            />
          </Grid>

          {/* PHONE */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Phone"
              value={formData.phone}
              onChange={(e) =>
                setFormData({ ...formData, phone: e.target.value })
              }
            />
          </Grid>

          {/* COUNTRY */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>Country</InputLabel>
              <Select
                value={formData.countryId || ""}
                label="Country"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    countryId: e.target.value,
                    stateId: "",
                    districtId: "",
                    cityId: "",
                  })
                }
              >
                {countries.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.countryName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* STATE */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>State</InputLabel>
              <Select
                value={formData.stateId || ""}
                label="State"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    stateId: e.target.value,
                    districtId: "",
                    cityId: "",
                  })
                }
              >
                {states.map((s) => (
                  <MenuItem key={s.id} value={s.id}>
                    {s.stateName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* DISTRICT */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>District</InputLabel>
              <Select
                value={formData.districtId || ""}
                label="District"
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    districtId: e.target.value,
                    cityId: "",
                  })
                }
              >
                {districts.map((d) => (
                  <MenuItem key={d.id} value={d.id}>
                    {d.districtName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* CITY / AREA */}
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth>
              <InputLabel>City / Area</InputLabel>
              <Select
                value={formData.cityId || ""}
                label="City / Area"
                onChange={(e) =>
                  setFormData({ ...formData, cityId: e.target.value })
                }
              >
                {cities.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.cityName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* PRIORITY */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Priority"
              value={formData.priority}
              onChange={(e) =>
                setFormData({ ...formData, priority: e.target.value })
              }
            >
              <MenuItem value="High">High</MenuItem>
              <MenuItem value="Medium">Medium</MenuItem>
              <MenuItem value="Low">Low</MenuItem>
            </TextField>
          </Grid>

          {/* STATUS */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              select
              label="Status"
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
            >
              <MenuItem value="New Lead">New Lead</MenuItem>
<MenuItem value="Contacted">Contacted</MenuItem>
<MenuItem value="Interested">Interested</MenuItem>
<MenuItem value="Demo Scheduled">Demo Scheduled</MenuItem>
<MenuItem value="Demo Completed">Demo Completed</MenuItem>
<MenuItem value="Proposal Sent">Proposal Sent</MenuItem>
<MenuItem value="Negotiation">Negotiation</MenuItem>
<MenuItem value="Follow Up">Follow Up</MenuItem>
<MenuItem value="Registered">Registered</MenuItem>
<MenuItem value="Rejected">Rejected</MenuItem>
<MenuItem value="Lost">Lost</MenuItem>
            </TextField>
          </Grid>
{/* CONTACTED BY */}
{(formData.status === "Contacted" || isEdit) && (
  <Grid item xs={12}>
    {isAdmin ? (
      <FormControl fullWidth>
        <InputLabel>Contacted By</InputLabel>

        <Select
          value={formData.contactedByUserId || ""}
          label="Contacted By"
          onChange={(e) =>
            setFormData({
              ...formData,
              contactedByUserId: e.target.value,
            })
          }
        >
          {users.map((user) => (
            <MenuItem
              key={user.id}
              value={user.id}
            >
              {user.userName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <TextField
        fullWidth
        disabled
        label="Contacted By"
        value={formData.contactedByUserName || ""}
      />
    )}
  </Grid>
)}

{/* DEMO COMPLETED BY */}
{(formData.status === "Demo Completed" || isEdit) && (
  <Grid item xs={12}>
    {isAdmin ? (
      <FormControl fullWidth>
        <InputLabel>Demo Completed By</InputLabel>

        <Select
          value={formData.demoCompletedByUserId || ""}
          label="Demo Completed By"
          onChange={(e) =>
            setFormData({
              ...formData,
              demoCompletedByUserId: e.target.value,
            })
          }
        >
          {users.map((user) => (
            <MenuItem
              key={user.id}
              value={user.id}
            >
              {user.userName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <TextField
        fullWidth
        disabled
        label="Demo Completed By"
        value={formData.demoCompletedByUserName || ""}
      />
    )}
  </Grid>
)}

{/* REGISTERED BY */}
{(formData.status === "Registered" || isEdit) && (
  <Grid item xs={12}>
    {isAdmin ? (
      <FormControl fullWidth>
        <InputLabel>Registered By</InputLabel>

        <Select
          value={formData.registeredByUserId || ""}
          label="Registered By"
          onChange={(e) =>
            setFormData({
              ...formData,
              registeredByUserId: e.target.value,
            })
          }
        >
          {users.map((user) => (
            <MenuItem
              key={user.id}
              value={user.id}
            >
              {user.userName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ) : (
      <TextField
        fullWidth
        disabled
        label="Registered By"
        value={formData.registeredByUserName || ""}
      />
    )}
  </Grid>
)}

{/* WHATSAPP INFO */}
{formData.whatsappStatus === "SENT" && (
  <>
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        disabled
        label="WhatsApp Sent By"
        value={formData.whatsappSentByUserName || "-"}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        disabled
        label="WhatsApp Sent Date"
        value={formData.whatsappSentDate || "-"}
      />
    </Grid>
  </>
)}

{formData.whatsappStatus === "SENT" && (
  <Grid item xs={12}>
    <TextField
      fullWidth
      select
      label="WhatsApp Response Status"
      value={formData.whatsappResponseStatus || ""}
      onChange={(e) =>
        setFormData({
          ...formData,
          whatsappResponseStatus: e.target.value,
        })
      }
    >
      <MenuItem value="ACCEPTED">Accepted</MenuItem>
      <MenuItem value="REJECTED">Rejected</MenuItem>
      <MenuItem value="NO_RESPONSE">No Response</MenuItem>
      <MenuItem value="PENDING">Pending</MenuItem>
    </TextField>
  </Grid>
)}

          {/* REMARKS */}
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Remarks"
              multiline
              rows={3}
              value={formData.remarks}
              onChange={(e) =>
                setFormData({ ...formData, remarks: e.target.value })
              }
            />
          </Grid>

        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button disabled={!checkPermission("CRM", "Sales Agent", "CREATE")} variant="contained" onClick={onSubmit}>
          {isEdit ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateSalesAgentDialog;